import React, { useEffect, useState } from 'react'
import { fetchListItems } from '../../../../../hooks/useCrud';
import { Link } from 'react-router-dom';
interface UiValeur {
    id?: number;
    titre?: string;
    description?: string;
    icone?: string;
    createdAt?: string;
    updatedAt?: string;
}
export default function FaireDon() {
    const [listData, setDataList] = useState<UiValeur[]>([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const fetchListData = async () => {
        setLoading(true);
        try {
            const res = await fetchListItems<UiValeur>('/fetch_fonctionalite_data');
            setDataList(res.data);

        } finally {
            setLoading(false);
        }

    }

    useEffect(() => {
        fetchListData();
    }, []);

    return (
        <div className="donation-process py-5  panel p-4 bg-gray-25 dark:bg-gray-800 rounded-lg">
            <div className="text-center mb-5">
                <h2 className="fw-bold text-primary text-3xl mb-2">Comment faire un don ?</h2>
                <p className="text-gray-600 fs-6">
                    Suivez ces étapes simples pour soutenir notre mission et transformer des vies.
                </p>
            </div>

            <div className="row g-1">
                {loading && <p>Chargement...</p>}
                {error && <p className="text-danger">{error}</p>}

                {listData.length > 0 ? (
                    listData.map((item, index) => (
                        <div className="col-md-6 col-lg-6" key={index}>
                            <div
                                className="
                                    process-step p-4 rounded-4 h-100 shadow-sm 
                                    position-relative bg-white dark:bg-gray-900 
                                    border border-gray-200 dark:border-gray-700
                                    transition-all duration-300 
                                    hover:shadow-xl hover:-translate-y-1
                                "
                            >
                              
                                {/* Icône circulaire */}
                                <div
                                    className="
                                        value-icon rounded-circle mx-auto mb-3
                                        hstack justify-center items-center
                                        bg-primary/10 text-primary
                                        transition-all duration-300
                                        hover:bg-primary hover:text-white
                                    "
                                    style={{
                                        width: "80px",
                                        height: "80px",
                                        fontSize: "32px",
                                    }}
                                >
                                    <i className={`fas fa-${item.icone}`}></i>
                                </div>

                                {/* Titre */}
                                <h4 className="fw-bold text-dark dark:text-white mb-2">
                                    {item.titre}
                                </h4>

                                {/* Description */}
                                <p className="text-gray-600 dark:text-gray-300 fs-6">
                                    {item.description}
                                </p>
                            </div>
                        </div>
                    ))
                ) : (
                    <p className="text-center">Aucun choix disponible</p>
                )}
            </div>

            <div className="row">
                <div className="col-12 text-center mt-2">
                    <Link to="/donation" className="btn btn-warning btn-lg btn-block w-100 w-md-auto">
                       <i className='fas fa-donate me-2'></i> Faire un Don Maintenant
                    </Link>
                </div>
            </div>
        </div>



    )
}
